import { render, staticRenderFns } from "./Legenda.vue?vue&type=template&id=4fad2553&scoped=true&"
import script from "./Legenda.vue?vue&type=script&lang=js&"
export * from "./Legenda.vue?vue&type=script&lang=js&"
import style0 from "./Legenda.vue?vue&type=style&index=0&id=4fad2553&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fad2553",
  null
  
)

export default component.exports